import React from 'react';
import PageHeader from './PageHeader';
import PageTitle from './PageTitle';
import ReportUniquePairingsDE from "../../../constants/ReportUniquePairingsDE";
import ColorGearImage from "../ColorGearImage";

const Results = ({ assessment }) => {
    const renderGenii = (genii, color) => {
        return (
            <>
                {genii.map((g, key) => {
                    return (
                        <div className='result' key={key}>
                            <div className='gear'>
                                <ColorGearImage
                                    type={g.label}
                                    color={color}
                                    height={'50px'}
                                    width={'50px'}
                                    style={{ marginLeft: '45px' }}
                                    lang={'de'}
                                />
                            </div>
                            <div className='text'>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: ReportUniquePairingsDE.Results[
                                            ReportUniquePairingsDE.getAbility(g.label)
                                        ][g.level],
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };

    return (
        <div className='QuantitativeResults'>
            <PageHeader title={'ERGEBNISSE'} />
            <div className='container'>
                <PageTitle title={'Ihre Ergebnisse'} className={'mt-16'} />
                <p className={'font-semibold text-14 mt-4 mb-6'}>
                    {assessment.participant.fname}, die folgenden Informationen fassen die Ergebnisse Ihres Assessments zusammen.
                </p>

                <div className='resultset genius'>
                    <h2 className={'text-xl font-bold'}>WORKING GENIUS:</h2>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: ReportUniquePairingsDE.Results.Genius(
                                ReportUniquePairingsDE.getAbility(assessment.customResults.genius1),
                                ReportUniquePairingsDE.getAbility(assessment.customResults.genius2),
                                ReportUniquePairingsDE.genius_color
                            ),
                        }}
                    />

                    {renderGenii(
                        [assessment.results.genii[0], assessment.results.genii[1]],
                        ReportUniquePairingsDE.genius_color
                    )}
                </div>

                <div className='resultset competency'>
                    <h2 className={'text-xl font-bold'}>WORKING COMPETENCY:</h2>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: ReportUniquePairingsDE.Results.Competency(
                                ReportUniquePairingsDE.getAbility(assessment.customResults.competency1),
                                ReportUniquePairingsDE.getAbility(assessment.customResults.competency2),
                                ReportUniquePairingsDE.competency_color
                            ),
                        }}
                    />

                    {renderGenii(
                        [assessment.results.genii[2], assessment.results.genii[3]],
                        ReportUniquePairingsDE.competency_color
                    )}
                </div>

                <div className='resultset frustration'>
                    <h2 className={'text-xl font-bold'}>WORKING FRUSTRATION:</h2>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: ReportUniquePairingsDE.Results.Frustration(
                                ReportUniquePairingsDE.getAbility(assessment.customResults.frustration1),
                                ReportUniquePairingsDE.getAbility(assessment.customResults.frustration2),
                                ReportUniquePairingsDE.frustration_color
                            ),
                        }}
                    />

                    {renderGenii(
                        [assessment.results.genii[4], assessment.results.genii[5]],
                        ReportUniquePairingsDE.frustration_color
                    )}
                </div>
            </div>
        </div>
    );
};

export default Results;
